import { render, staticRenderFns } from "./TutorialEdit.vue?vue&type=template&id=5b58bd88&scoped=true"
import script from "./TutorialEdit.vue?vue&type=script&lang=js"
export * from "./TutorialEdit.vue?vue&type=script&lang=js"
import style0 from "./TutorialEdit.vue?vue&type=style&index=0&id=5b58bd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58bd88",
  null
  
)

export default component.exports